// page routes
export const HOME = '/';
export const EXPERIENCE = '/experience';
export const CONTACT = '/contact';
export const NOT_FOUND = '/not-found';

export const REDIRECT = '';